import requestAction from '../../utils/requestAction'
import { volatilAction } from '../../utils/sequenceActions'

export const fetchAssignation = (assignationId: string) =>
  volatilAction(requestAction('ASSIGNATION_DETAIL')(`assignations/${assignationId}`, 'GET'))
